import {useEffect, useRef, useState} from 'react';
import { HubConnectionBuilder, HubConnection } from '@microsoft/signalr';

interface ConnectionMethods {
    method: string,
    newMethod: (message: any) => void
}

interface UseSignalRProps {
    connectionString: string,
    connectionMethods: ConnectionMethods | ConnectionMethods[],
    reconnectCallBack?: () => void,
    connectionCloseCallback?: () => void,
    dependencyArray?: any[]
}

const useSignalR= ({connectionString, connectionMethods, dependencyArray=[], reconnectCallBack= () => {}, connectionCloseCallback= () => {}}: UseSignalRProps) => {
    const connection = useRef<HubConnection>();
    const [connected, setConnected] = useState(false);

    function getConnectionString(connectionSuffix: string){
        const urlParts= window.location.href.split('/');
        const domainParts = urlParts[2].split('.');

        const isFeature = domainParts.includes('tab-feature');
        const isLocal = domainParts.includes('local:2228')
        
        const connectionString = [
            isFeature ?  `sockets.${domainParts[1]}` : 'sockets',
            isFeature ? domainParts[2] : domainParts[1],
            isLocal ? 'local:2225' : domainParts[domainParts.length -1]
        ]
        
        //sanitise connection suffix
        connectionSuffix = connectionSuffix[0] === '/' ? connectionSuffix : `/${connectionSuffix}`

        return `${urlParts[0]}//${connectionString.join('.')}${connectionSuffix}`;
    }

    function connectionMethodsToArray(con: ConnectionMethods | ConnectionMethods[]): ConnectionMethods[] {
        return Array.isArray(con) ? con : [con]
    }

    useEffect(()=> {
        const hubConnection = new HubConnectionBuilder()
            .withUrl(getConnectionString(connectionString))
            .withAutomaticReconnect()
            .build();
        
        // add event listeners
        for(let i of connectionMethodsToArray(connectionMethods)){
            hubConnection.on(i.method, i.newMethod);
        }

        hubConnection
            .start()
            .then(() => {
                //console.log('connected')
                setConnected(true)
            });
            //.catch(e => console.log('Connection failed: ', e));

        hubConnection.onclose(()=> {
            setConnected(false)
            connectionCloseCallback()
        });
        hubConnection.onreconnected(()=> {
            console.log('reconnected sockets')
            setConnected(true)
            reconnectCallBack()
        });
        connection.current = hubConnection;

        // disconnect on page unload
        window.addEventListener("beforeunload", function (e) {
            hubConnection.stop();
        })

        return () => {
            hubConnection.stop();
            setConnected(false)
            connectionCloseCallback();
        }
    }, dependencyArray)

    return {connected, connection: connection.current}
}

export default useSignalR